import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class RecipientAudit extends Model {
  static get modelName() {
    return 'RecipientAudit';
  }

  static reducer({ type, data }, RecipientAudit) {
    switch (type) {
      case LOAD.SUCCESS:
        RecipientAudit.delete();
        if (data.response) {
          data.response.forEach((r) => RecipientAudit.upsert(r));
        }
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      changelog: attr(),
      id: attr(),
      logAt: attr(),
      logOp: attr(),
      recipientId: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(RecipientAudit.modelName);
export const load = createAction(LOAD);
